import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import styled from '@emotion/styled';
import InputFilterTableColumns from './InputFilterTableColumns';
import { FilterUploadHistory } from '../../../../../interfaces/interfaces';
import tableHeadCellNames from '../uploadHistory.mock';
import InputDataPicker from './InputDataPicker';

interface TableHeadUploadHistoryProps {
  cleanInputs: object;
  setFilterData(x: Partial<FilterUploadHistory>): void;
}
const StyledColumnName = styled.span`
  font-weight: 600;
`;

const labelsInputList = ['uploadedBy', 'fileType', 'fileContent', 'fileSource', 'version', 'fileName', 'uploadStatus'];

const TableHeadUploadHistory = React.memo(({ setFilterData, cleanInputs }: TableHeadUploadHistoryProps) => {
  return (
    <TableHead>
      <TableRow>
        {Object.entries(tableHeadCellNames).map(([label, item]) => (
          <TableCell
            key={label}
            sx={{
              padding: '16px 5px',
            }}
          >
            <StyledColumnName>{item}</StyledColumnName>
            {labelsInputList.some((i) => i === label) && (
              <InputFilterTableColumns label={label} setFilterData={setFilterData} cleanInputs={cleanInputs} />
            )}
            {(label === 'uploadedOn' || label === 'fileLastUpdated') && (
              <InputDataPicker label={label} setFilterData={setFilterData} cleanInputs={cleanInputs} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
});

export default TableHeadUploadHistory;
